import { useTranslation } from 'react-i18next';

export const ChargePointsReasonsHeader = (): React.JSX.Element => {
  const { t } = useTranslation();

  return <>{t('$.dashboard.maintenance.table.reasons')}</>;
};
